import { BagFloatingButton, FloatingButtonsContainer } from './components';

export const FloatingButtons = {
  Container: FloatingButtonsContainer,
  Bag: BagFloatingButton,
} as const;
